import React, {useCallback, useMemo} from 'react';
import Home from './pages/home';
import Me from './pages/me';
import Referral from './pages/referral';
import {createBottomTabNavigator} from '@react-navigation/bottom-tabs';
import {ImageURISource} from 'react-native';
import {NavigatorScreenProps} from '@types';
import Scratch from './pages/new-scratch';
import {useTranslation} from 'react-i18next';
import Invitation from './common-pages/invitation';
import Navbar from './components/navbar';
import Promotion from './pages/promotions';
import Leaderboard from './common-pages/leaderboard';
import {useShowLeaderboardRect} from '@/common-pages/leaderboard/hooks/useShowLeaderboardRect';
import {currentBrand} from '@/brands';
import Result from './common-pages/result';

const Tab = createBottomTabNavigator();

type PageConfig = {
  name: string;
  link: string;
  component: (props: NavigatorScreenProps) => React.JSX.Element;
  img: ImageURISource;
  activeImg: ImageURISource;
  unmountOnBlur?: boolean;
  hide?: boolean;
  lazy?: boolean;
  initialParams?: any;
};

export const getMainPageList = (showJackpot: boolean): PageConfig[] => {
  if (currentBrand.key === 'anna') {
    return [
      {
        name: 'Home',
        link: 'index/home',
        component: Home,
        img: require('@assets/icons/home/home.webp'),
        activeImg: require('@assets/icons/home/home-active.webp'),
      },
      {
        name: 'Result',
        link: 'index/result',
        component: Result,
        img: require('@assets/icons/home/result.webp'),
        activeImg: require('@assets/icons/home/result-active.webp'),
      },
      {
        name: 'Referral',
        link: 'index/referral',
        component: Referral,
        img: require('@assets/icons/home/referral.webp'),
        activeImg: require('@assets/icons/home/referral-active.webp'),
      },
      {
        name: 'Me',
        link: 'index/me',
        component: Me,
        img: require('@assets/icons/home/me.webp'),
        activeImg: require('@assets/icons/home/me-active.webp'),
      },
    ];
  }

  const baseList: PageConfig[] = [
    {
      name: 'Home',
      link: 'index/home',
      component: Home,
      img: require('@assets/icons/home/home.webp'),
      activeImg: require('@assets/icons/home/home-active.webp'),
    },
    {
      name: 'Invitation',
      link: 'index/invitation',
      component: Invitation,
      img: require('@assets/icons/home/earn.webp'),
      activeImg: require('@assets/icons/home/earn-active.webp'),
    },
    {
      name: 'ScratchNew',
      link: 'index/scratch',
      component: Scratch,
      img: require('@assets/icons/home/scratch.webp'),
      activeImg: require('@assets/icons/home/scratch-active.webp'),
    },
  ];

  const finalPageList: PageConfig[] = [];
  finalPageList.push(...baseList.slice(0, 3));

  if (showJackpot) {
    finalPageList.push({
      name: 'jackpot',
      link: 'leaderboard',
      component: Leaderboard,
      img: require('@assets/icons/home/rank.webp'),
      activeImg: require('@assets/icons/home/rank.webp'),
      initialParams: {type: 'OLD_USER_RANK_ACTIVITY'},
    });
  } else {
    finalPageList.push({
      name: 'Promotions',
      link: 'index/promotion',
      component: Promotion,
      img: require('@assets/icons/home/promotion.webp'),
      activeImg: require('@assets/icons/home/promotion-active.webp'),
      initialParams: {tabKey: 'promotion'},
    });
  }

  finalPageList.push({
    name: 'Me',
    link: 'index/me',
    component: Me,
    img: require('@assets/icons/home/me.webp'),
    activeImg: require('@assets/icons/home/me-active.webp'),
  });

  return finalPageList;
};

export const mainPageList = getMainPageList(false);

const annaTabTitleMap: Record<string, string> = {
  Home: 'Home',
  Result: 'Result',
  Referral: 'Invite',
  Me: 'Account',
};

const getTabTitle = (name: string, isAnna: boolean, i18n: any) => {
  if (isAnna) {
    return annaTabTitleMap[name] || name;
  }

  if (name === 'ScratchNew') {
    return 'Get ₹200';
  }

  return i18n.t(`home.tab.${name.toLocaleLowerCase()}`);
};

const MainNav = () => {
  const {i18n} = useTranslation();
  const {OLD_USER_RANK_ACTIVITY} = useShowLeaderboardRect();
  const isAnna = currentBrand.key === 'anna';

  const dynamicPageList = useMemo(() => {
    return getMainPageList(OLD_USER_RANK_ACTIVITY);
  }, [OLD_USER_RANK_ACTIVITY]);
  const renderTabBar = useCallback(
    (props: any) => <Navbar {...props} list={dynamicPageList} />,
    [dynamicPageList],
  );

  return (
    <Tab.Navigator
      tabBar={renderTabBar}
      screenOptions={{
        headerShown: false,
      }}
      backBehavior="none">
      {dynamicPageList.map(v => (
        <Tab.Screen
          key={v.name}
          name={v.name}
          component={v.component}
          options={{
            title: getTabTitle(v.name, isAnna, i18n),
            unmountOnBlur: v.unmountOnBlur,
            lazy: v.lazy,
          }}
          initialParams={v.initialParams}
        />
      ))}
    </Tab.Navigator>
  );
};

export default MainNav;
